import React from "react";
import {useTranslation} from "react-i18next";
function Header() {
    const [showMenu, setShowMenu] = React.useState<boolean>(false);
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const otherLang = currentLang === 'zh' ? 'en' : 'zh';
    const otherLabel = currentLang === 'zh' ? 'English' : '中文';

    const switchLanguage = () => {
        const path = window.location.pathname;
        const newPath = path.replace(/^\/(en|zh)(\/|$)/, `/${otherLang}$2`);
        window.location.href = newPath + window.location.search;
    };
    return (
        <header>
            <div className="header-area header-transparrent ">
                <div className="main-header header-sticky">
                    <div className="container">
                        <div className="row align-items-center">

                            <div className="col-xl-2 col-lg-2 col-md-2">
                                <div className="logo">
                                    <a href="/"><img src="./logo129.png" style={{ maxWidth: '100px' }} alt=""></img></a>
                                </div>
                            </div>
                            <div className="col-xl-10 col-lg-10 col-md-10">

                                <div className="main-menu f-right d-none d-lg-block">
                                    <nav>
                                        <ul id="navigation">
                                            <li className="active"><a href="/">{t('home')}</a></li>
                                            <li><a href="/hybrid/moduleList.html">{t('product')}</a></li>
                                            <li><a href="/hybrid/downloadCenter.html">{t('downloadHead')}</a></li>
                                            <li><a href="/hybrid/tutorialList.html">{t('tutorial')}</a></li>
                                            <li><a onClick={switchLanguage} style={{ cursor: 'pointer' }}>{otherLabel}</a></li>
                                            {/* <li><a href="https://preview.colorlib.com/theme/appco/#">Pages</a>
                                                <ul className="submenu">
                                                    <li><a href="https://preview.colorlib.com/theme/appco/blog.html">Blog</a></li>
                                                    <li><a href="https://preview.colorlib.com/theme/appco/single-blog.html">Blog Details</a></li>
                                                    <li><a href="https://preview.colorlib.com/theme/appco/elements.html">Element</a></li>
                                                </ul>
                                            </li> */}
                                            {/* <li><a href="https://preview.colorlib.com/theme/appco/contact.html">Contact</a></li> */}
                                        </ul>
                                    </nav>
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="mobile_menu d-block d-lg-none"><div className="slicknav_menu">
                                    <a onClick={()=>{setShowMenu(!showMenu)}} aria-haspopup="true" role="button" tabIndex={0} className="slicknav_btn slicknav_collapsed" style={{ outline: 'none' }}><span className="slicknav_menutxt">{t('menu')}</span><span className="slicknav_icon"><span className="slicknav_icon-bar"></span><span className="slicknav_icon-bar"></span><span className="slicknav_icon-bar"></span></span></a>
                                    <ul className="slicknav_nav slicknav_hidden" aria-hidden="true" role="menu" style={{ display: showMenu ? 'block' : 'none' }}>
                                        <li className="active"><a href="/" role="menuitem" tabIndex={-1}>{t('home')}</a></li>
                                        <li><a href="/hybrid/moduleList.html" role="menuitem" tabIndex={-1}>{t('product')}</a></li>
                                        <li><a href="/hybrid/downloadCenter.html" role="menuitem" tabIndex={-1}>{t('downloadHead')}</a></li>
                                        <li><a href="tutorial" role="menuitem" tabIndex={-1}>{t('tutorial')}</a></li>
                                        <li><a onClick={switchLanguage} role="menuitem" tabIndex={-1} style={{ cursor: 'pointer' }}>{otherLabel}</a></li>
                                        {/* <li><a href="https://preview.colorlib.com/theme/appco/services.html" role="menuitem" tabIndex={-1}>Services</a></li> */}
                                        {/* <li><a href="https://preview.colorlib.com/theme/appco/pricing.html" role="menuitem" tabIndex={-1}>Pricing</a></li> */}
                                        {/* <li className="slicknav_collapsed slicknav_parent"><a href="https://preview.colorlib.com/theme/appco/#" role="menuitem" aria-haspopup="true" tabIndex={-1} className="slicknav_item slicknav_row" style={{ outline: 'none' }}><a href="https://preview.colorlib.com/theme/appco/#" tabIndex={-1}>Pages</a>
                                            <span className="slicknav_arrow">+</span></a><ul className="submenu slicknav_hidden" role="menu" aria-hidden="true" style={{ display: 'none' }}>
                                                <li><a href="https://preview.colorlib.com/theme/appco/blog.html" role="menuitem" tabIndex={-1}>Blog</a></li>
                                                <li><a href="https://preview.colorlib.com/theme/appco/single-blog.html" role="menuitem" tabIndex={-1}>Blog Details</a></li>
                                                <li><a href="https://preview.colorlib.com/theme/appco/elements.html" role="menuitem" tabIndex={-1}>Element</a></li>
                                            </ul>
                                        </li> */}
                                        {/* <li><a href="https://preview.colorlib.com/theme/appco/contact.html" role="menuitem" tabIndex={-1}>Contact</a></li> */}
                                    </ul></div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header >
    );
}

export default Header;
